<template>
    <ul
        ref="wrapper"
        :class="{
            [theme.wrapper]: true,
            [theme.active]: active,
        }"
    >
        <li
            v-for="option in options"
            :key="`option-${option.name}`"
            @click="click(option.name)"
        >
            <i :class="option.icon"></i>
            <span>{{ option.label }}</span>
        </li>
    </ul>
</template>

<script>
import Common from './mixins/Common.vue';

export default {
    mixins: [Common],
    props: {
        data: Object,
        options: Array,
    },
    data() {
        return {
            active: false,
            contextMenuWidth: null,
            contextMenuHeight: null,
        };
    },
    mounted() {
        window.addEventListener('click', () => {
            if (this.active) this.hide();
        });
    },
    methods: {
        show() {
            const event = window.event;

            const menu = this.$refs.wrapper;
            if (!this.contextMenuWidth || !this.contextMenuHeight) {
                this.contextMenuWidth = menu.offsetWidth;
                this.contextMenuHeight = menu.offsetHeight;
            }

            if (this.contextMenuWidth + event.pageX >= window.innerWidth) {
                menu.style.left = event.pageX - this.contextMenuWidth + 'px';
            } else {
                menu.style.left = event.pageX + 'px';
            }

            let top = event.pageY;
            if (this.contextMenuHeight + event.pageY >= window.innerHeight) {
                top -= this.contextMenuHeight;
            }
            top -= document.documentElement.scrollTop;
            menu.style.top = top + 'px';

            this.active = true;
        },
        hide() {
            this.active = false;
            this.$emit('hidden');
        },
        click(option) {
            this.$emit('option-selected', option);
        },
    },
};
</script>

<style lang="scss" module></style>
<style
    lang="scss"
    module="theme_default"
    src="./../css/themes/default/context_menu.scss"
></style>
<style
    lang="scss"
    module="theme_simple"
    src="./../css/themes/simple/context_menu.scss"
></style>
